<template>
  <div class="sub-route">
    <section class="app-section" id="patientAdd">
      <div>
        <Icon type="ios-contact" />
        &nbsp;基本信息
      </div>
      <Card style="margin-top:10px;">
        <Form ref="formValidate" :model="form" :rules="rules" :label-width="80">
          <FormItem label="姓名" prop="name">
            <Input v-model="form.name" placeholder="请填写姓名" :size="formSize"></Input>
          </FormItem>
          <FormItem label="身份证" prop="id_card">
            <Input v-model="form.id_card" placeholder="请填写身份证" :size="formSize"></Input>
          </FormItem>
          <FormItem label="门诊号" prop="clinic_no">
            <Input v-model="form.clinic_no" placeholder="请填写门诊号" :size="formSize"></Input>
          </FormItem>
          <FormItem label="住院号">
            <Input v-model="form.inpatient_no" placeholder="请填写住院号" :size="formSize"></Input>
          </FormItem>
          <FormItem label="住址" prop="address">
            <Input v-model="form.address" placeholder="请填写住址" :size="formSize"></Input>
          </FormItem>
          <FormItem label="主要诊断" prop="diagnosis">
            <Select v-model="form.diagnosis" placeholder="请选择主要诊断" :size="formSize">
              <Option v-for="(i, index) in diagnosises" :value="i.value" :key="'diagnosis_' + index">{{i.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="电话(本人)" prop="phone">
            <Input v-model="form.phone" placeholder="请填写本人电话" :size="formSize"></Input>
          </FormItem>
          <FormItem label="电话(备用)">
            <Input v-model="form.phone_second" placeholder="请填写备用电话" :size="formSize"></Input>
          </FormItem>
          <FormItem label="所属社区" prop="community">
            <Select v-model="form.community" placeholder="请选择所属社区" :size="formSize" @on-change="changeCommunity">
              <OptionGroup v-for="(i, index) in communitys" :label="i.title" :key="'orgGroup_' + index">
                <Option v-for="(j, _index) in i.children" :value="j.id + ''" :key="'org_' + _index">{{ j.name }}</Option>
              </OptionGroup>
            </Select>
          </FormItem>
          <FormItem label="所属团队" prop="team">
            <Select v-model="form.team" placeholder="请选择所属团队" :size="formSize" :not-found-text="form.community ? '该社区下没有团队' : '请先选择所属社区'">
              <Option v-for="(i, index) in teams" :value="i.id + ''" :key="'team_' + index">{{i.name}}</Option>
            </Select>
          </FormItem>
          <FormItem label="接诊医生" prop="doctor_code">
            <Select v-model="form.doctor_code" filterable remote :remote-method="onDoctorSearch" :loading="loadingDoctor" placeholder="输入接诊医生姓名搜索" :size="formSize">
              <Option v-for="(i, index) in doctors" :value="i.username" :key="'doctor_' + index">{{i.name}}</Option>
            </Select>
          </FormItem>
        </Form>
      </Card>

      <div style="text-align:center;margin-top:16px;">
        <Button :size="formSize" @click="closePage()">取消</Button>
        <Button type="primary" style="margin-left:20px" :size="formSize" @click="submitAndPerfect()">保存并完善信息</Button>
        <Button type="primary" style="margin-left:20px" :size="formSize" @click="submitAndNext()">保存并继续添加</Button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'patientAdd',
  data: function () {
    return {
      diagnosises: [
        {
          text: '哮喘',
          value: '哮喘'
        },
        {
          text: '慢阻肺',
          value: '慢阻肺'
        }
      ],
      communitys: [],
      all_teams: [],
      doctors: [],
      form: {
        name: '',
        id_card: '',
        clinic_no: '',
        inpatient_no: '',
        address: '',
        diagnosis: '',
        phone: '',
        community: '',
        team: '',
        phone_second: '',
        doctor_code: '',
        doctor_name: ''
      },
      rules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        id_card: [
          { required: true, message: '请填写身份证', trigger: 'blur' },
          { type: 'string', min: 18, max: 18, message: '请填写合法身份证', trigger: 'blur' }
        ],
        clinic_no: [
          { required: true, message: '请填写门诊号', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请填写住址', trigger: 'blur' }
        ],
        diagnosis: [
          { required: true, message: '请选择主要诊断', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请填写本人电话', trigger: 'blur' }
        ],
        community: [
          { required: true, message: '请选择所属社区', trigger: 'change' }
        ],
        team: [
          { required: true, message: '请选择所属团队', trigger: 'change' }
        ],
        doctor_code: [
          { required: true, message: '请选择就诊医生', trigger: 'change' }
        ]
      },
      formSize: 'default',
      loadingDoctor: false
    }
  },
  computed: {
    teams: function () {
      let self = this
      return this.all_teams.filter(item => {
        return item.medical_institution_id + '' === self.form.community + ''
      })
    }
  },
  methods: {
    changeCommunity: function () {
      this.form.team = ''
    },
    getAllTeams: function () { // 获取所有的团队
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('MANAGEMENT_MEDICAL_TEAM'),
        data: {
          page: 1,
          size: 9999
        },
        success: function (res) {
          if (res.code === 0) {
            self.all_teams = res.data
          } else {
            self.$Message.error(res.message)
          }
        }
      })
    },
    onDoctorSearch: function (query) { // 接诊医生搜索
      var self = this
      self.loadingDoctor = true
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('USER_SEARCH_NAME') + '/' + query.replace(/\s/g),
        success: function (res) {
          self.loadingDoctor = false
          if (res.code === 0) {
            self.doctors = res.data
          } else {
            self.$Message.error(res.message)
          }
        }
      })
    },
    closePage: function () { // 关闭选项卡
      this.$utils.closePage({
        type: 'patientAdd',
        title: '',
        id: 0
      })
    },
    getSheQuList: function () { // 获取社区列表
      var self = this
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('MANAGEMENT_MEDICAL_INSTITUTION'),
        data: {
          page: 1,
          size: 9999
        },
        success: function (res) {
          if (res.code === 0) {
            self.communitys = [
              // {
              //   title: '上级机构',
              //   children: []
              // },
              {
                title: '社区机构',
                children: []
              }
            ]
            res.data.forEach(item => {
              if (item.type === 1) {
                self.communitys[0].children.push(item)
              }
            })
          } else {
            self.$Message.error(res.message)
          }
        }
      })
    },
    submitAndPerfect: function () { // 保存并完善信息
      var self = this
      self.submit((res) => {
        // console.log(res)
        self.$utils.closePage({ // 关闭新增患者窗口
          type: 'patientAdd',
          id: 0
        })
        setTimeout(_ => {
          self.$utils.openPage({ // 打开患者详情窗口
            type: 'patientDetail',
            title: self.form.name,
            id: res.user_id,
            params: {
              user_id: res.user_id
            }
          })
        })
      })
    },
    submitAndNext: function () { // 保存并继续添加
      var self = this
      self.submit((res) => {
        self.form = {
          name: '',
          id_card: '',
          clinic_no: '',
          inpatient_no: '',
          address: '',
          diagnosis: '',
          phone: '',
          community: '',
          team: '',
          phone_second: '',
          doctor_code: '',
          doctor_name: ''
        }
        self.$refs.formValidate.resetFields()
      })
    },
    submit: function (callback) { // 提交
      var self = this
      var form = self.form
      self.$refs.formValidate.validate((valid) => {
        if (valid) {
          self.$utils.loadingShow()
          var doctors = self.doctors.filter((item) => {
            return item.username === form.doctor_code
          })
          self.form.doctor_name = doctors && doctors[0] && doctors[0].name || ''
          self.$utils.caringRequest({
            method: 'POST',
            url: self.$utils.getInterface('PATIENT'),
            headers: {
              'content-type': 'application/json'
            },
            data: JSON.stringify({
              di_zhi: form.address,
              first_phone: form.phone,
              id_card: form.id_card,
              inpatient_code: form.inpatient_no,
              name: form.name,
              outpatient_code: form.clinic_no,
              second_phone: form.phone_second,
              she_qu_id: form.team, // 特殊处理，其实是团队id
              yi_sheng: form.doctor_name,
              yi_sheng_code: form.doctor_code,
              zhu_yao_zhen_duan: form.diagnosis
            }),
            success: function (res) {
              self.$utils.loadingHide()
              if (res.code === 0) {
                self.$store.commit('setRefreshPatientList')
                self.$Message.success('新增患者成功')
                callback(res.data) // res.data 为插入到数据库的id
              } else {
                self.$Message.error(res.message)
              }
            }
          })
        }
      })
    }
  },
  mounted: function () {
    this.getSheQuList()
    this.getAllTeams()
  }
}
</script>

<style lang="less">
  @import '../../styles/common.less';

  #patientAdd {
    background-color: @background-color;

    .ivu-form-item {
      display: inline-block;
      width: 48%;
    }
  }
</style>
